import { render } from "./Share.vue?vue&type=template&id=4be8703a&ts=true"
import script from "./Share.vue?vue&type=script&lang=ts"
export * from "./Share.vue?vue&type=script&lang=ts"

import "./Share.vue?vue&type=style&index=0&id=4be8703a&lang=scss"

import exportComponent from "/home/runner/work/digital-creative-website/digital-creative-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__